'use strict';

import React from 'react';
import PubSub from 'pubsub-js';

var pModel= require('./static/model_pca_20_svm.js');
var emotionClassifier = require('./static/emotion_classifier.js');
var emotionModel = require('./static/emotionmodel.js');
//require('styles//Detector.css');

class DetectorComponent extends React.Component {
	constructor(props){
		super(props);

		this.state = {
			emotion: "",
			emotionValue: 0
		};

		this.vid = null;
		this.overlay = null;
		this.overlayCC = null;
		this.ctrack = null;
		this.emotionClassifier = null;
		this.emotionData = null;
		this.trackingStarted = false;
		this.emotion = "";
		this.stream = null;

		this.init = this.init.bind(this);
		this.enablestart = this.enablestart.bind(this);
		this.gumSuccess = this.gumSuccess.bind(this);
		this.gumFail = this.gumFail.bind(this);
		this.loop = this.loop.bind(this);
	}

	componentDidMount(){

		const script = document.createElement('script');
		script.setAttribute(
			'src', 
			'https://cdnjs.cloudflare.com/ajax/libs/clmtrackr/1.0.2/clmtrackr.min.js');
		script.addEventListener('load', () => {
		    this.init()
		});
		document.body.appendChild(script);
		
		PubSub.subscribe('CAMERA_STOP', (e,d) => {
			if(this.stream)this.stream.getVideoTracks()[0].stop();
		});
	}

	init(){
		this.vid = document.getElementById('videoel');
		this.vid.addEventListener('canplay', this.enablestart, false);

		this.emotionClassifier = new emotionClassifier();
		console.log(emotionModel)
		this.emotionClassifier.init(emotionModel);
		this.emotionData = this.emotionClassifier.getBlank();

		pModel.shapeModel.nonRegularizedVectors.push(9);
		pModel.shapeModel.nonRegularizedVectors.push(11);

		this.ctrack = new clm.tracker({useWebGL : true});
		this.ctrack.init(pModel);
		this.trackingStarted = false;

		navigator.getUserMedia = navigator.getUserMedia 
		|| navigator.webkitGetUserMedia 
		|| navigator.mozGetUserMedia 
		|| navigator.msGetUserMedia;
		window.URL = window.URL 
		|| window.webkitURL 
		|| window.msURL 
		|| window.mozURL;
		// check for camerasupport
		if (navigator.mediaDevices) {
			navigator.mediaDevices.getUserMedia({video : true}).then(this.gumSuccess).catch(this.gumFail);
		} else if (navigator.getUserMedia) {
			navigator.getUserMedia({video : true}, this.gumSuccess, this.gumFail);
		} else {
			alert("This demo depends on getUserMedia, which your browser does not seem to support. :(");
		}
	}
	/********** check and set up video/webcam **********/
	gumFail(err) {
		alert("Scared of NSA?");
		PubSub.publish('EMOTION', {
			type: "scared",
			value: 0.51
		});
	}
	gumSuccess( stream ) {
		this.stream = stream;
		
		// add camera stream if getUserMedia succeeded
		if ("srcObject" in this.vid) {
			this.vid.srcObject = stream;
		} else {
			this.vid.src = (window.URL && window.URL.createObjectURL(stream));
		}
		this.vid.onloadedmetadata = function() {
			//adjustVideoProportions();
			//this.vid.play();
		}
	
	}
	
	enablestart() {
		this.ctrack.start(this.vid);
		this.trackingStarted = true;

		if( !this._frameId ) {
		    this._frameId = window.requestAnimationFrame( this.loop );
		}
	}

	loop() {
		this._frameId = window.requestAnimationFrame( this.loop )
	
		var cp = this.ctrack.getCurrentParameters();
		var er = this.emotionClassifier.meanPredict(cp);
		if (er) {
			//updateData(er);
			for (var i = 0;i < er.length;i++) {
				//console.log(er[i])
				if (er[i].emotion == "happy"){
					//console.log(er[i].value)
					PubSub.publish('EMOTION', {
						type: er[i].emotion,
						value: er[i].value
					});
					
				}
			}
		}
	}

	render() {
		return (
			<div className="detector-component">
				<video id="videoel" width="400" height="300" preload="auto" loop playsInline autoPlay></video>
				<div>{this.state.emotion}</div>
				<div>{this.state.emotionValue}</div>
			</div>
		);
	}
}

DetectorComponent.displayName = 'DetectorComponent';

// Uncomment properties you need
// DetectorComponent.propTypes = {};
// DetectorComponent.defaultProps = {};

export default DetectorComponent;



// WEBPACK FOOTER //
// ./src/components/smile-detector/DetectorComponent.js